<div  class="sidebar" [class.expanded]="isExpanded" [ngClass]="{'expanded': isExpanded}">
  <div class="toggle-btn" (click)="toggleSidebar()">
    <mat-icon *ngIf="!isExpanded" matSuffix class="arrow"
      style="vertical-align:sub; border: 1px solid white;border-radius: 12px;padding-bottom: 23px;">chevron_right</mat-icon>
    <mat-icon *ngIf="isExpanded" matSuffix class="arrow"
      style="vertical-align:sub; border: 1px solid white;border-radius: 12px;padding-bottom: 23px; padding-right: 24px;">chevron_left</mat-icon>
  </div>
  <div class="profile_block">
    <div class="profile_letter">{{UserNameAsPhoto}}</div>
    <div *ngIf="isExpanded" class="profile_name">{{SelectedBusinessInfoName}}<mat-icon class="material-symbols-outlined "
        style="vertical-align: top; margin-left: 10px;" 
        (click)="toggleSecondSidebar()">repeat</mat-icon>
      </div>
  </div>
  <div class="sidebar_text" *ngIf="isExpanded" style="margin-left: 30px;font-size: 18px;margin-bottom: 10px;">30/11/2024 Product Expiry</div>
  <div class="content_bar">
    
    <!-- <button *ngIf="!isExpanded" class="add_button" routerLink="/Dashboard/ManageBusiness">+</button> -->
    <div class="menu_item" routerLink="/Dashboard/Profile" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">person</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Profile</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/Home" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">calendar_month</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Event</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/ManageBusiness" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">business_center</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Manage Business</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/SocialMediaAccounts" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">group</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Social Media Accounts</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/AI" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">psychology</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Sharkify AI</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/AdsManager" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">ads_click</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Ads Manager</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/Analytics" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">analytics</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Analytics</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/Plans" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">query_stats</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Plans</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/RequestList" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">quick_reference_all</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Access Request</div>
    </div>
    <div class="menu_item" routerLink="/Dashboard/PaymentHistory" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">payments</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Payment History</div>
    </div>
    <div class="menu_item" (click)="logout()" routerLink="/Home" routerLinkActive="active-menu">
      <mat-icon matSuffix class="material-symbols-outlined" style="vertical-align:sub;">logout</mat-icon>
      <div class="sidebar_text" *ngIf="isExpanded">Logout</div>
    </div>
  </div>
</div>
<div *ngIf="isSecondSidebarExpanded" class="second-sidebar" [class.expanded]="isSecondSidebarExpanded">
  <div class="toggle-btn" (click)="toggleSecondSidebar()">
    <mat-icon *ngIf="isSecondSidebarExpanded" matSuffix class="arrow"
      style="vertical-align:sub; border: 1px solid white; border-radius: 12px; padding-bottom: 23px; padding-right: 24px;">
      close
    </mat-icon>
  </div>

  <div class="content_bar">
    <div class="user_business_title">Business Names</div>
      <div class="business_item" *ngFor="let list_of_business_names of BusinessInfoData; let i = index">
        <div class="user_business_name"  (click)="onButtonClick(i)">{{ list_of_business_names.BusinessInfo_BusinessName }} <mat-icon *ngIf="list_of_business_names.BusinessInfoId.toString() != CheckBusinessInfoId" class="material-symbols-outlined "
          style="vertical-align: top; margin-left: 10px; float: right;">repeat</mat-icon></div>
      </div>
  </div>
</div>
<div class="content_page" >
  <!-- [ngStyle]="{'margin-left': BusinessInfo > 0 ? '60px' : '0px',}" [ngStyle]="{'margin-left': isExpanded ? '250px' : '0px'}" -->
  <router-outlet></router-outlet>
</div>

<div *ngIf="isPopupVisible" class="popup_overlay">
  <div class="popup_content">
    <div class="popup_title">Switch Business</div>
    <div class="popup_description">Would you like to Switch the Business</div>
    <button class="pop_up_buttons" style=" margin-right: 20px;" (click)="onSwitch(Index,false,false)" >Switch</button>
    <button class="pop_up_buttons" (click)="closePopup()">Cancel</button>
  </div>
</div>